
var getPrev = function (elem) {
    if (elem.prev().length === 0) {
        return elem.siblings().last();
    }
    else {
        return elem.prev();
    }
}
var getNext = function (elem) {
    if (elem.next().length === 0) {
        return elem.siblings().first();
    }
    else {
        return elem.next();
    }
}

export function initsliders(){
    function sliderLightbox(slider, clickedElement) {
        var _this = this;
        this.slider = slider;
        this.clickedElement = clickedElement;
        this.slideProgressing = false;
        this.lightbox = $(slider.siblings(".slider-lightbox"));

        this.loadItems = function () {
            var caption = "";

            var unordered = this.slider.find(".items .item").toArray();

            for (var x = 0; x < unordered.length; x++) {
                var newNaviPoint = $("<li data-number=" + x + "></li>")
                this.lightbox.find("ul.navi").append(newNaviPoint);
            }
            this.lightbox.find("ul.navi li[data-number=" + clickedElement.data("number") + "]").addClass("now");

            while ($(unordered[0]).is(clickedElement) != true) {
                unordered.push(unordered.shift());
            }

            var ordered = unordered;

            $(ordered).each(function () {
                var img = $(this).find("figure img").attr("src");
                var alt = $(this).find("figure img").attr("alt");
                var number = $(this).data("number");
                caption = $(this).find("figcaption").text();

                var newItem = $('<div class="lightbox-item" data-number="' + number + '"><figure><img src="' + img + '" alt="' + alt + '"><figcaption><p>' + caption + '</p></figcaption></figure></div>');
                _this.lightbox.find(".lightbox-items").append(newItem);
            });
            this.lightbox.find(".lightbox-items .lightbox-item").first().addClass("active");
            this.lightbox.find(".text p").text($(ordered[0]).find("figcaption").text());
        };

        this.destroy = function () {
            this.lightbox.find(".lightbox-item").remove();
            this.lightbox.find(".text p").empty();
            this.lightbox.find(".navi").children().remove();
            this.lightbox.hide();
            $("body").css("overflow", "");
            $(window).off("resize", _this.scaleLightbox);
            $("body").off("click", ".slider-lightbox .close", _this.destroyHandlerClose);
            this.lightbox.off("click", _this.destroyHandlerOutside);
            this.lightbox.off("click", "button[data-direction=left]", _this.destroyHandlerLeftArrow);
            this.lightbox.off("click", "button[data-direction=right]", _this.destroyHandlerRightArrow);

            delete this;
        };

        this.nextOrFirst = function (elem, type) {
            if (elem.nextAll(type).length === 0) {
                return elem.parent().children(type).first();
            }
            return elem.nextAll(type).first();
        };

        this.prevOrLast = function (elem, type) {
            if (elem.prevAll(type).length === 0) {
                return elem.parent().children(type).last();
            }
            return elem.prevAll(type).first();
        };

        this.slideRight = function () {
            if (this.slideProgressing) {
                return;
            }
            this.slideProgressing = true;

            var dotNow = $(this.lightbox.find("ul.navi li.now"));
            var dotNew = this.nextOrFirst(dotNow, "li");

            dotNow.removeClass("now");
            dotNew.addClass("now");

            var current = this.lightbox.find(".lightbox-item.active");
            var next = $(this.lightbox.find(".lightbox-item.active").nextAll(".lightbox-item")[0]);
            var dur = 400;

            next.addClass("active");
            next.css("position", "absolute");
            next.css("left", "100%");
            next.css("top", "0");
            next.css("width", "100%");

            current.css("position", "relative");

            current.animate({
                left: "-=100%"
            }, {
                complete: function () {
                    current.attr("style", "");
                    current.removeClass("active");
                    current.appendTo(current.parent());
                    _this.slideProgressing = false;
                }
            });

            next.animate({
                left: "-=100%"
            }, {
                complete: function () {
                    next.attr("style", "");
                }
            });
            this.lightbox.find(".text p").animate({
                opacity: 0
            }, {
                duration: dur / 2,
                complete: function () {
                    _this.lightbox.find(".text p").empty();
                    _this.lightbox.find(".text p").text(next.find("figcaption p").text());
                    _this.lightbox.find(".text p").animate({
                        opacity: 1
                    }, {
                        duration: dur / 2
                    });
                }
            });

        }

        this.slideLeft = function () {
            if (this.slideProgressing) {
                return;
            }
            this.slideProgressing = true;

            var dotNow = $(this.lightbox.find("ul.navi li.now"));
            var dotNew = this.prevOrLast(dotNow, "li");

            dotNow.removeClass("now");
            dotNew.addClass("now");

            var current = this.lightbox.find(".lightbox-item.active");
            var prev = $(this.lightbox.find(".lightbox-item.active").nextAll(".lightbox-item").last());
            var dur = 400;

            prev.addClass("active");
            prev.css("position", "absolute");
            prev.css("right", "100%");
            prev.css("top", "0");
            prev.css("width", "100%");

            current.css("position", "relative");

            current.animate({
                right: "-=100%"
            }, {
                duration: dur,
                easing: "linear",
                complete: function () {
                    current.attr("style", "");
                    current.removeClass("active");
                    _this.slideProgressing = false;
                }
            });

            prev.animate({
                right: "-=100%"
            }, {
                duration: dur,
                easing: "linear",
                complete: function () {
                    prev.attr("style", "");
                    prev.prependTo(prev.parent());
                }
            });
            this.lightbox.find(".text p").animate({
                opacity: 0
            }, {
                duration: dur / 2,
                complete: function () {
                    _this.lightbox.find(".text p").empty();
                    _this.lightbox.find(".text p").text(prev.find("figcaption p").text());
                    _this.lightbox.find(".text p").animate({
                        opacity: 1
                    }, {
                        duration: dur / 2
                    });
                }
            });
        }

        this.stepRight = function () {
            if (this.slideProgressing) {
                return;
            }

            var dotNow = $(this.lightbox.find("ul.navi li.now"));
            var dotNew = this.nextOrFirst(dotNow, "li");

            dotNow.removeClass("now");
            dotNew.addClass("now");

            var current = this.lightbox.find(".lightbox-item.active");
            var next = $(this.lightbox.find(".lightbox-item.active").nextAll(".lightbox-item")[0]);

            next.addClass("active");
            current.removeClass("active");
            current.appendTo(current.parent());

            _this.lightbox.find(".text p").empty();
            _this.lightbox.find(".text p").text(next.find("figcaption p").text());

        }

        this.stepLeft = function () {
            if (this.slideProgressing) {
                return;
            }

            var dotNow = $(this.lightbox.find("ul.navi li.now"));
            var dotNew = this.prevOrLast(dotNow, "li");

            dotNow.removeClass("now");
            dotNew.addClass("now");

            var current = this.lightbox.find(".lightbox-item.active");
            var prev = $(this.lightbox.find(".lightbox-item.active").nextAll(".lightbox-item").last());

            prev.addClass("active");
            current.removeClass("active");
            prev.prependTo(prev.parent());

            _this.lightbox.find(".text p").empty();
            _this.lightbox.find(".text p").text(prev.find("figcaption p").text());
        }

        this.directToSlide = function (elem) {
            if (this.slideProgressing) {
                return;
            }
            var distance = $(elem).data("number") - this.lightbox.find("ul.navi .now").data("number");

            if (distance < 0) {
                var times = distance * -1;
                for (var x = 0; x < times; x++) {
                    this.stepLeft();
                }
            } else if (distance > 0) {
                for (var x = 0; x < distance; x++) {
                    this.stepRight();
                }
            }
            this.lightbox.find("ul.navi .now").removeClass("now");
            $(elem).addClass("now");

        }

        this.scaleLightbox = function () {
            if (_this.lightbox.is(":visible")) {
                if ($(window).innerHeight() / $(window).innerWidth() < 0.85) {
                    var viewportHeight = $(window).innerHeight();
                    _this.lightbox.find(".lightbox-items img").css("height", viewportHeight * 0.75 + "px");
                    _this.lightbox.find(".lightbox-items img").css("width", "auto");
                } else {
                    var viewPortWidth = $(window).innerWidth();
                    _this.lightbox.find(".lightbox-items img").css("height", "auto");
                    _this.lightbox.find(".lightbox-items img").css("width", "100%");
                }

                _this.lightbox.find(".text").css("width", "auto");
                var imgWidth = _this.lightbox.find(".lightbox-items img").width();
                _this.lightbox.find(".text").css("width", imgWidth > 0 ? imgWidth : "");

            }
        }

        this.destroyHandlerClose = function (e) {
            e.preventDefault();
            e.stopPropagation();
            _this.destroy();
        }

        this.destroyHandlerOutside = function (e) {
            if ($(e.target).hasClass("slider-lightbox")) {
                _this.destroy();
            }
        }

        this.destroyHandlerRightArrow = function (e) {
            _this.stepRight();
        }

        this.destroyHandlerLeftArrow = function (e) {
            _this.stepLeft();
        }

        this.destroyHandlerSlideSelector = function (e) {
            _this.directToSlide(this);
        }

        this.destroyHandlerSwipeLeft = function () {
            _this.stepRight();
        }

        this.destroyHandlerSwipeRight = function () {
            _this.stepLeft();
        }

        $("body").on("click", ".slider-lightbox .lb-close", _this.destroyHandlerClose);
        $(window).on("resize", _this.scaleLightbox);
        this.lightbox.on("click", _this.destroyHandlerOutside);
        this.lightbox.on("click", "button[data-direction=left]", _this.destroyHandlerLeftArrow);
        this.lightbox.on("click", "button[data-direction=right]", _this.destroyHandlerRightArrow);
        this.lightbox.on("click", "ul.navi li", _this.destroyHandlerSlideSelector);
        this.lightbox.swipe({
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                if (distance > 20 && direction === "left") {
                    _this.stepRight();
                } else if (distance > 20 && direction === "right") {
                    _this.stepLeft();
                }
                console.log("direction: " + direction);
            },
            fingers: 'all'
        });
        this.loadItems();
        this.lightbox.show();
        $("body").css("overflow", "hidden");
        this.scaleLightbox();
    }
//Image slider with lightbox

    function imgSliderWthLightbox(slider) {
        var _this = this;
        this.slider = slider;
        this.slideProgressing = false;
        this.mode = "";

        var number = 0;
        this.slider.find(".item").each(function () {
            $(this).data("number", number++);
        });

        this.nextOrFirst = function (elem) {
            if (elem.next().length === 0) {
                return elem.siblings().addBack().first();
            } else {
                return elem.next();
            }
        }
        this.prevOrLast = function (elem) {
            if (elem.prev().length === 0) {
                return elem.siblings().addBack().last();
            } else {
                return elem.prev();
            }
        }
        this.checkMode = function () {
            var width = parseFloat((parseInt($($(".imgslider-wth-lightbox")[0]).find(".item").css("width")) / parseInt($($(".imgslider-wth-lightbox")[0]).css("width")).toFixed(2)).toFixed(2));
            var items = this.slider.find(".item.active");
            if (width === 0.33) {
                this.mode = "third";

                var first = $(items[0]);
                var second = this.nextOrFirst(first);
                var third = this.nextOrFirst(second);

                this.slider.find(".item.active").removeClass("active");

                first.addClass("active");
                second.addClass("active");
                third.addClass("active");

                if (this.slider.find(".item").length === 3) {
                    this.slider.find("button").hide();
                } else {
                    this.slider.find("button").show();
                }

            } else if (width === 0.5) {
                this.mode = "half";

                var first = $(items[0]);
                var second = this.nextOrFirst(first);

                this.slider.find(".item.active").removeClass("active");
                first.addClass("active");
                second.addClass("active");

                this.slider.find("button").show();
            } else if (width === 1) {
                this.mode = "whole";

                var first = $(items[0]);
                this.slider.find(".item.active").removeClass("active");
                first.addClass("active");

                this.slider.find("button").show();
            }

        }
        this.checkMode();
        $(window).on("resize", function () {
            _this.checkMode();
        });
        this.slideLeft = function () {
            if (this.slideProgressing === true) {
                console.log("running");
                return;
            }
            this.slideProgressing = true;
            var offset = this.slider.find(".item.active").width();

            var prev = this.prevOrLast(this.slider.find(".item.active").first());
            prev.prependTo(prev.parent());
            var gone = this.slider.find(".item.active").last();

            prev.css("display", "inline-block");
            prev.css("position", "absolute");
            prev.css("top", "0").css("left", "-" + offset + "px").css("width", offset).css("bottom", "0");

            this.slider.find(".item.active").animate({
                left: offset
            }, {
                complete: function () {
                    gone.removeClass("active");
                    //gone.appendTo(gone.parent());
                    _this.slider.find(".item").attr("style", "");
                    _this.slideProgressing = false;

                },
                step: function () {

                }
            });
            prev.animate({
                left: "0"
            }, {
                complete: function () {
                    prev.attr("style", "");
                },
                step: function () {

                }
            });
            prev.addClass("active");
        };
        this.slideRight = function () {
            if (this.slideProgressing === true) {
                console.log("running");
                return;
            }
            this.slideProgressing = true;
            var offset = this.slider.find(".item.active").width();

            var next = this.nextOrFirst(this.slider.find(".item.active").last());
            var gone = this.slider.find(".item.active").first();

            next.css("display", "inline-block");
            next.css("position", "absolute");
            next.css("top", "0").css("right", "-" + offset + "px").css("width", offset).css("bottom", "0");

            this.slider.find(".item.active").animate({
                right: offset
            }, {
                complete: function () {
                    gone.removeClass("active");
                    gone.appendTo(gone.parent());
                    _this.slider.find(".item").attr("style", "");
                    _this.slideProgressing = false;

                },
                step: function () {
                    //console.log("hey");
                }
            });
            next.animate({
                right: "0"
            }, {
                complete: function () {
                    next.attr("style", "");
                },
                step: function () {

                }
            });
            next.addClass("active");
        };

        this.stepLeft = function () {
            if (this.slideProgressing) {
                return;
            }
            var next = this.prevOrLast(this.slider.find(".item.active").first());
            var current = this.slider.find(".item.active").last();

            next.addClass("active");
            current.removeClass("active");
            next.prependTo(current.parent());
        };

        this.stepRight = function () {
            if (this.slideProgressing) {
                return;
            }
            var next = this.nextOrFirst(this.slider.find(".item.active").last());
            var current = this.slider.find(".item.active").first();

            next.addClass("active");
            current.removeClass("active");
            current.appendTo(current.parent());
        }

        this.swipeLeftHandler = function () {
            //this.stepLeft();
            this.slideLeft();
        };

        this.swipeRightHandler = function () {
            //this.stepRight();
            this.slideRight();
        };

        this.slider.swipe({
            swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
                if (distance > 20 && direction === "left") {
                    _this.stepRight();
                } else if (distance > 20 && direction === "right") {
                    _this.stepLeft();
                }
                console.log("direction: " + direction);
            },
            fingers: 'all'
        });

        $(_this.slider).on("touchstart click", "button[data-direction=left]", function (e) {
            e.stopPropagation();
            e.preventDefault();
            //_this.stepLeft();
            _this.slideLeft();
        });
        $(_this.slider).on("touchstart click", "button[data-direction=right]", function (e) {
            e.stopPropagation();
            e.preventDefault();
            //_this.stepRight();
            _this.slideRight();
        });

        $(this.slider).on("click", ".item:not(.linkonly) figure", function (e) {
            new sliderLightbox($(e.currentTarget).parents(".imgslider-wth-lightbox"), $(e.currentTarget).parent());
        });
        imgSliderWthLightbox.objects.push(this);

        if (this.slider.find(".item.first").length > 0 && this.slider.find(".item").length > 3) {
            while (!this.slider.find(".item").first().is(this.slider.find(".item.first"))) {
                _this.stepRight();
            }
        }
    }
    imgSliderWthLightbox.objects = [];

    for (var x = 0; x < $(".imgslider-wth-lightbox").length; x++) {
        new imgSliderWthLightbox($($(".imgslider-wth-lightbox")[x]));
    }

//Image slider

    let slideProgressing = undefined;

    function slideLeft(slider) {
        if (_this.slideProgressing) {
            return;
        }

        var activeElement = slider.find(".item.active");

        if (activeElement.prev().length === 0) {
            var nextElement = activeElement.parent().children().last();
        } else {
            var nextElement = activeElement.prev();
        }


        activeElement.animate({
            "right": "-=100%"
        }, {
            duration: "slow",
            start: function () {
                activeElement.css("position", "relative");
            }
        });

        nextElement.css("display", "block");
        nextElement.css("position", "absolute");
        nextElement.css("top", "0").css("left", "-100%").css("width", "100%").css("bottom", "0");


        nextElement.animate({
            "left": "+=100%"
        }, {
            duration: "slow",
            start: function () {
                slideProgressing = true;
            },
            complete: function () {
                nextElement.attr("style", "");
                nextElement.addClass("active");
                activeElement.removeClass("active");
                slideProgressing = false;
            }
        });
    };

    function slideRight(slider) {
        if (slideProgressing) {
            return;
        }

        var activeElement = slider.find(".item.active");

        if (activeElement.next().length === 0) {
            var nextElement = activeElement.parent().children().first();
        } else {
            var nextElement = activeElement.next();
        }

        activeElement.animate({
            "left": "-=100%"
        }, {
            duration: "slow",
            start: function () {
                activeElement.css("position", "relative");
            }
        });

        nextElement.css("display", "block");
        nextElement.css("position", "absolute");
        nextElement.css("top", "0").css("left", "100%").css("width", "100%").css("bottom", "0");

        nextElement.animate({
            "left": "-=100%"
        }, {
            duration: "slow",
            start: function () {
                slideProgressing = true;
            },
            complete: function () {
                nextElement.attr("style", "");
                nextElement.addClass("active");
                activeElement.removeClass("active");
                slideProgressing = false;
            }
        });
    }

    const initiateSlider = () => {

        $(".imgslider-wth-infobox .items .item:first-child").addClass("active");

        $(".imgslider-wth-infobox").each(function () {
            if ($(this).find(".item").length === 1) {
                $(this).children("button").hide();
            }
        });

        slideProgressing = undefined;

        $(".imgslider-wth-infobox").on("click", function () {
            $(this).find(".item.active figcaption").stop(true, true).fadeToggle();
        });

        $(".imgslider-wth-infobox").on("click", ".item.active figcaption", function (e) {
            e.stopPropagation();
        });

        $(".imgslider-wth-infobox button[data-direction=left]").on("click", function (e) {
            e.stopPropagation();
            slideLeft($(this).parent());
            $(this).parent().find(".item.active figcaption").stop(true, true).fadeOut();
        });
        $(".imgslider-wth-infobox button[data-direction=right]").on("click", function (e) {
            e.stopPropagation();
            slideRight($(this).parent());
            $(this).parent().find(".item.active figcaption").stop(true, true).fadeOut();
        });
    }

    initiateSlider();

    if (!$(".relaunch-big-slider").hasClass("disablesliding")) {
        setInterval(function () {
            if (!$("body").hasClass("lightbox-active") && !$("body").hasClass("tinybox-active") && !$(".relaunch-big-slider").hasClass("stopped")) {
                $(".relaunch-big-slider .sliderbutton.right").trigger("click");
            }
        }, 4000);

        $(".relaunch-big-slider").on("click", ".items img", function () {

            var that = $(this);
            if (!that.parents(".relaunch-big-slider").hasClass("stopped")) {
                that.parents(".relaunch-big-slider").addClass("stopped");
                that.parents(".relaunch-big-slider").find(".slidestop").css("opacity", "1");
                setTimeout(function () {
                    that.parents(".relaunch-big-slider").find(".slidestop").css("opacity", "0");
                }, 500);
            }
            else {
                that.parents(".relaunch-big-slider").addClass("play").removeClass("stopped");
                that.parents(".relaunch-big-slider").find(".slideplay").css("opacity", "1");
                setTimeout(function () {
                    that.parents(".relaunch-big-slider").find(".slideplay").css("opacity", "0");
                }, 500);
            }

        });

        function setButtonVisibility() {
            if ($(".relaunch-big-slider .items .item").length <= 1) {
                $(".relaunch-big-slider .sliderbutton").hide();
            }
            else {
                $(".relaunch-big-slider .sliderbutton").show();
            }
        }

        setButtonVisibility();
    }




    $(".relaunch-big-slider").swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
            if ($(this).find(".item").length < 2) {
                return;
            }
            if (direction === "right") {
                console.log("sliding left");
                var slider = $(this);
                if (slider.hasClass("running")) {
                    return;
                }
                else {
                    slider.addClass("running");
                }
                var current = $(this).find(".item.active");
                var prev = getPrev(current);
                prev.addClass("prev");

                setTimeout(function () {
                    prev.css("right", "0");
                    current.css("left", "100%");
                    setTimeout(function () {
                        current.removeAttr("style");
                        current.removeClass("active");
                        prev.removeAttr("style");
                        prev.addClass("active");
                        prev.removeClass("prev");
                        slider.removeClass("running");
                    }, 1000);

                }, 100);
            }
            else if (direction === "left") {
                var slider = $(this);
                if (slider.hasClass("running")) {
                    return;
                }
                else {
                    slider.addClass("running");
                }
                var current = $(this).find(".item.active");
                var next = getNext(current);
                next.addClass("next");

                setTimeout(function () {
                    next.css("left", "0");
                    current.css("left", "-100%");
                    setTimeout(function () {
                        current.removeAttr("style");
                        current.removeClass("active");
                        next.removeAttr("style");
                        next.addClass("active");
                        next.removeClass("next");
                        slider.removeClass("running");
                    }, 1000);

                }, 100);

            }
        }
    })

    $(".relaunch-big-slider").on("click", "button.sliderbutton.left", function (e) {
        e.stopPropagation();
        var slider = $(this).parents(".relaunch-big-slider");
        if (slider.hasClass("running")) {
            return;
        }
        else {
            slider.addClass("running");
        }
        var current = $(this).siblings(".items").find(".item.active");
        var prev = getPrev(current);
        prev.addClass("prev");

        setTimeout(function () {
            prev.css("right", "0");
            current.css("left", "100%");
            setTimeout(function () {
                current.removeAttr("style");
                current.removeClass("active");
                prev.removeAttr("style");
                prev.addClass("active");
                prev.removeClass("prev");
                slider.removeClass("running");
            }, 1000);

        }, 100);
    });
    $(".relaunch-big-slider").on("click", "button.sliderbutton.right", function (e) {
        e.stopPropagation();
        var slider = $(this).parents(".relaunch-big-slider");
        if (slider.hasClass("running")) {
            return;
        }
        else {
            slider.addClass("running");
        }
        var current = $(this).siblings(".items").find(".item.active");
        var next = getNext(current);
        next.addClass("next");

        setTimeout(function () {
            next.css("left", "0");
            current.css("left", "-100%");
            setTimeout(function () {
                current.removeAttr("style");
                current.removeClass("active");
                next.removeAttr("style");
                next.addClass("active");
                next.removeClass("next");
                slider.removeClass("running");
            }, 1000);

        }, 100);

    });


    //Neuer Slider

    var initSliderElements = function (slider) {
        slider.find(".slider-item").removeClass("slider-inactive");
        var first = slider.find(".slider-item:first-child");
        var firstOffset = first.offset().top;
        var differentOffset = $();

        slider.find(".slider-item").each(function () {
            if ($(this).offset().top !== firstOffset) {
                differentOffset = differentOffset.add($(this));
            }
        });

        differentOffset.addClass("slider-inactive");
    };

    var initSliderMargins = function (slider) {
        var first = slider.find(".slider-item:first-child");
        var sliderMargin = parseFloat(slider.css("margin-left"));
        var negativeMargin = parseFloat(first.css("margin-left"));

    };

    var initSliderButtons = function (slider) {
        if (slider.find(".slider-inactive").length > 0) {
            var posY = slider.find(".slider-item:not(.slider-inactive):first-child img").height() / 2 + "px";
            var buttons = $('<div class="slider-button left" style="top:' + posY + ';"></div><div class="slider-button right" style="top:' + posY + ';"></div>');
            slider.find(".slider-button").remove();
            slider.append(buttons);
        }
    };

    $(".relaunch-slider").each(function () {
        initSliderElements($(this));
        initSliderMargins($(this));
        initSliderButtons($(this));
    });
    $(window).on("resize", function () {
        $(".relaunch-slider").each(function () {
            initSliderElements($(this));
            initSliderMargins($(this));
            initSliderButtons($(this));
        });
    });

    var onSliderLeft = function (slider) {
        var first = slider.find(".slider-item:not(.slider-inactive)").eq(0);
        if (slider.hasClass("sliding")) {
            return;
        }
        slider.addClass("sliding");
        var prev = slider.find(".slider-inactive").last();
        var visible = slider.find(".slider-item:not(.slider-inactive)");
        prev.width(first[0].getBoundingClientRect().width);
        if (prev.length > 0) {
            var sliderMargin = parseFloat(slider.css("margin-left"));
            var itemMargin = parseFloat(first.css("margin-left"));

            prev.addClass("prev");
            visible.addClass("animate-left");

            setTimeout(function () {
                prev.addClass("transition").css("transform", "translateX(calc(100% + " + itemMargin * 2 + "px)) translateZ(0)");
                visible.addClass("transition").css("transform", "translateX(calc(100% + " + itemMargin * 2 + "px)) translateZ(0)");
                visible.last().css("opacity", 0);
                setTimeout(function () {
                    prev.removeClass("prev transition slider-inactive").prependTo(slider).attr("style", "");
                    visible.removeClass("animate-left transition").attr("style", "");
                    visible.last().addClass("slider-inactive");
                    slider.removeClass("sliding");
                }, 500);
            }, 1);


        }
    };

    var onSliderRight = function (slider) {
        var first = slider.find(".slider-item:not(.slider-inactive)").eq(0);
        if (slider.hasClass("sliding")) {
            return;
        }
        slider.addClass("sliding");
        var next = slider.find(".slider-inactive").first();
        var visible = slider.find(".slider-item:not(.slider-inactive)");
        next.width(first[0].getBoundingClientRect().width);
        if (next.length > 0) {
            var sliderMargin = parseFloat(slider.css("margin-left"));
            var itemMargin = parseFloat(first.css("margin-left"));

            next.addClass("next");
            visible.addClass("animate-left");

            setTimeout(function () {
                next.addClass("transition").css("transform", "translateX(calc(-100% - " + itemMargin * 2 + "px)) translateZ(0)");
                visible.addClass("transition").css("transform", "translateX(calc(-100% - " + itemMargin * 2 + "px)) translateZ(0)");
                visible.first().css("opacity", 0);
                setTimeout(function () {
                    next.removeClass("next transition slider-inactive").insertAfter(visible.last()).attr("style", "");
                    visible.removeClass("animate-left transition").attr("style", "");
                    visible.first().addClass("slider-inactive").appendTo(slider);
                    slider.removeClass("sliding");
                }, 500);
            }, 1);


        }
    };
    $(".relaunch-slider").on("click", ".slider-button.left", function () {
        onSliderLeft($(this).parents(".relaunch-slider"));
    });
    $(".relaunch-slider").on("click", ".slider-button.right", function () {
        onSliderRight($(this).parents(".relaunch-slider"));
    });
    $(".relaunch-slider").swipe({
        swipe: function (event, direction, distance, duration, fingerCount, fingerData) {
            if (distance > 20 && direction === "left") {
                onSliderRight($(this));
            } else if (distance > 20 && direction === "right") {
                onSliderLeft($(this));
            }
        },
        fingers: 'all'
    });


    $(".swipeslider").each(function () {
        "use strict";
        var swipeslider = $(this);
        var itemNode = swipeslider.find(".swipeslider__items");
        var labelNode = swipeslider.find(".swipeslider__label")[0];
        var isStatic = itemNode.children(".swipeslider__item").length === 1 ? true : false;
        var isEmpty = itemNode.children(".swipeslider__item").length === 0 ? true : false;

        function setLabel(item){
            if(!(item)){
                return;
            }
            if(item !== undefined && item.getAttribute("data-title") !== null && item.getAttribute("data-title") !== ""){
                labelNode.innerHTML = item.getAttribute("data-title");
            }
        }
        setLabel(itemNode.find(".swipeslider__item")[0]);


        function initSlider(){
            var protoPos = { lastPos: 0, currentLeft: 0, lastStartPos: 0, transitioning: false, isActive: false, animationDone: false, direction: undefined, snapCandidate: undefined };
            var pos = Object.create(protoPos);
            var steps = [];
            var limits = undefined;



            function getSteps(){
                steps = itemNode.find(".swipeslider__item").toArray().map(function(item){
                    var marginLeft = parseInt(window.getComputedStyle(item).marginLeft);
                    var marginRight = parseInt(window.getComputedStyle(item).marginRight);

                    var leftEdge = item.getBoundingClientRect().x - itemNode[0].getBoundingClientRect().x;
                    var leftEdgeWithMargin = leftEdge - marginLeft;

                    var width = item.getBoundingClientRect().width;
                    var widthWithMargin = width + marginLeft + marginRight;

                    var rightEdge = leftEdge + width;
                    var rightEdgeWithMargin = leftEdgeWithMargin + widthWithMargin;


                    return { leftEdge: leftEdge, leftEdgeWithMargin: leftEdgeWithMargin, width: width, widthWithMargin: widthWithMargin, rightEdge:rightEdge, rightEdgeWithMargin:rightEdgeWithMargin, node:item};
                });
            }
            getSteps();

            function getAdjacent(direction){
                let snapCandidate = null;
                let currentOverlap = 0;

                let leftEdge = Math.abs(new (typeof(WebKitCSSMatrix) === "undefined" ? MSCSSMatrix : WebKitCSSMatrix)(window.getComputedStyle(itemNode[0]).transform).e);
                let rightEdge = leftEdge + itemNode[0].getBoundingClientRect().width;

                let stepsLocal = direction === "left" ? steps.slice().reverse() : steps;

                let x = 0;
                for(let step of stepsLocal){
                    let overlap = Math.max(0, Math.min(rightEdge, step["rightEdgeWithMargin"]) - Math.max(leftEdge, step["leftEdgeWithMargin"]));
                    snapCandidate = overlap >= currentOverlap ? step.node : snapCandidate;
                    currentOverlap = overlap >= currentOverlap ? overlap : currentOverlap;
                }

                pos.snapCandidate = direction === "left" ? snapCandidate.previousElementSibling : snapCandidate.nextElementSibling;
                pos.direction = direction;
            }

            function getSnapCandidate(){
                let snapCandidate = null;
                let leftEdge = Math.abs(new (typeof(WebKitCSSMatrix) === "undefined" ? MSCSSMatrix : WebKitCSSMatrix)(window.getComputedStyle(itemNode[0]).transform).e);
                let rightEdge = leftEdge + itemNode[0].getBoundingClientRect().width;

                let relevantEdge = (pos.direction ?? "right") === "left" ? leftEdge : rightEdge;

                for(var x = 0; x <= steps.length - 1; x++){
                    if(relevantEdge  >= steps[x]["leftEdgeWithMargin"] && relevantEdge <= steps[x]["rightEdgeWithMargin"] ){
                        snapCandidate = itemNode.find(".swipeslider__item").eq(x);

                        pos.snapCandidate = snapCandidate[0];


                    }

                    let overlap = Math.max(0, Math.min(rightEdge, steps[x]["rightEdgeWithMargin"]) - Math.max(leftEdge, steps[x]["leftEdgeWithMargin"]));
                    // console.log([leftEdge, rightEdge, steps[x]["leftEdgeWithMargin"], steps[x]["rightEdgeWithMargin"]]);
                    // console.log("overlap: " + overlap);
                }

                //pos.snapCandidate = undefined;
            }

            function snapTo(){
                if(!pos.snapCandidate){
                    return;
                }
                for(let step of steps){
                    if($(step["node"]).is(pos.snapCandidate)){
                        //console.log("snapping to: ");
                        //console.log(pos.snapCandidate);


                        let newPosition = 0;
                        if(pos.direction === "right"){
                            newPosition = -step["leftEdge"] + itemNode[0].getBoundingClientRect().width - step["width"];
                        }
                        else{
                            newPosition = (-step["leftEdge"])
                        }
                        //console.log([newPosition,pos.currentLeft]);
                        if(pos.currentLeft === newPosition){
                            return;
                        }

                        if(Math.abs(newPosition - pos.currentLeft) > 10 ){ //no animation for snap under 10 px
                            itemNode.on("transitionend",snapCompleteHandler);

                            itemNode.css("transition", "transform 0.3s ease");
                        }

                        pos.currentLeft = newPosition;

                        itemNode.css("transform", "translateX(" + pos.currentLeft + "px)");

                        setLabel(pos.snapCandidate);
                    }
                }
            }

            function snapCompleteHandler(){
                itemNode.off("transitionend",snapCompleteHandler);
                itemNode.css("transition", "none");
                itemNode[0].offsetWidth;
            }

            var detectLimits = function () {
                limits = {
                    left: 0,
                    width: itemNode.find(".swipeslider__item").toArray().reduce(
                        (total, i) => {
                            var marginSum = parseInt(window.getComputedStyle(i).marginLeft) + parseInt(window.getComputedStyle(i).marginRight);
                            return total + i.getBoundingClientRect().width + marginSum;
                        }, 0)
                };
            };
            detectLimits();

            swipeslider.find(".swipeslider__right").on("click",function(){
                getAdjacent("right");
                snapTo();

            });
            swipeslider.find(".swipeslider__left").on("click",function(){
                getAdjacent("left");
                snapTo();

            });

            var reset = function () {
                pos = Object.create(protoPos);
                pos.animationDone = true;
                itemNode.attr("style", "");
                itemNode.off("transitionend", transitionCancelHandler);
                $("body").off("mousemove touchmove", moveHandler);
                $("body").off("mouseup touchend", bodyOnMouseUpHandler);
                itemNode.off("transitionend",snapCompleteHandler);
                swipeslider.find(".swipeslider__scroll").removeClass("swipeslider__scroll--animate");
                detectLimits();
                getSteps();
                itemNode[0].offsetWidth;
                setLabel(itemNode.find(".swipeslider__item")[0]);
            }
            var transitionCancelHandler = function () {
                if (pos.transitioning) {
                    pos.currentLeft = new (typeof(WebKitCSSMatrix) === "undefined" ? MSCSSMatrix : WebKitCSSMatrix)(window.getComputedStyle(itemNode[0]).transform).e;
                    itemNode.css("transition", "none");
                    itemNode.off("transitionend", transitionCancelHandler);
                    itemNode.css("transform", "translateX(" + pos.currentLeft + "px)");
                    itemNode[0].offsetWidth;
                    pos.animationDone = true;
                    pos.transitioning = false;

                }
            }
            var animateScroll = function () {
                if(itemNode.hasClass("noanimate")){
                    return;
                }
                if(itemNode.children(".swipeslider__item").length === 1){
                    pos.animationDone = true;
                    return;
                }
                itemNode.css("transition", "transform 5s ease");
                itemNode[0].offsetWidth;
                itemNode.on("transitionend", transitionCancelHandler);
                itemNode.css("transform", "translateX(" + (pos.currentLeft - 50) + "px)");

                swipeslider.find(".swipeslider__scroll").addClass("swipeslider__scroll--animate");
                pos.transitioning = true;
            }

            var moveHandler = function (e) {

                var posOriginEvent = e.type === "touchmove" ? e.originalEvent.touches[0] : e;

                var pointerPos = posOriginEvent.pageX;
                var offset = pointerPos - pos.lastPos;
                pos.lastPos = pointerPos;
                var newLeft = pos.currentLeft + offset;

                if (offset === 0) {
                }
                else if (offset > 0) {
                    pos.direction = "left";
                    if (newLeft < limits.left) {
                        pos.currentLeft = pos.currentLeft + offset;
                    }
                    else {
                        pos.currentLeft = limits.left;
                    }
                    itemNode.css("transform", "translateX(" + pos.currentLeft + "px)");
                }
                else {
                    pos.direction = "right";
                    if (-pos.currentLeft + itemNode.width() < limits.width) {
                        pos.currentLeft = pos.currentLeft + offset;
                    }
                    else {
                        pos.currentLeft = itemNode.width() - limits.width;
                    }
                    itemNode.css("transform", "translateX(" + pos.currentLeft + "px)");

                }

            };

            var bodyOnMouseUpHandler = function(e){
                // e.preventDefault();
                // e.stopPropagation();
                // e.stopImmediatePropagation();
                var posOriginEvent = e.originalEvent instanceof TouchEvent ? e.originalEvent.changedTouches[0] : e;
                var distance = Math.abs(pos.lastStartPos - posOriginEvent.pageX);
                if(distance >= 10){
                    getSnapCandidate();
                    snapTo();
                    e.preventDefault();
                    e.stopPropagation();
                    e.stopImmediatePropagation();
                }
                else{
                    if(e.target.getAttribute("data-href")){
                        if(typeof e.target.fireET !== "undefined"){
                            try{
                                e.target.fireET();
                            }
                            catch(e){
                                console.warn(e.message);
                            }
                        }
                        window.open(e.target.getAttribute("data-href"), '_blank').focus();
                    }
                }

                $("body").off("mousemove touchmove", moveHandler);
                $("body").off("mouseup touchend", bodyOnMouseUpHandler);
            };

            if(!itemNode.hasClass("notouch")){
                itemNode.on("mousedown touchstart", function (e) {
                    e.preventDefault();

                    pos.isActive = true;
                    transitionCancelHandler();
                    var posOriginEvent = e.type === "touchstart" ? e.originalEvent.touches[0] : e;
                    pos.lastPos = posOriginEvent.pageX;
                    pos.lastStartPos = posOriginEvent.pageX;

                    $("body").on("mousemove touchmove", moveHandler);
                    $("body").on("mouseup touchend", bodyOnMouseUpHandler);
                });
            }


            $(window).on("resize", function () {
                reset();
            });

            $(window).on("scroll", function () {
                if (pos.animationDone) {
                    return;
                }
                var el = itemNode[0];
                var rect = el.getBoundingClientRect();

                var vpHeight = (window.innerHeight || document.documentElement.clientHeight);
                var vpBoundaryBottom = vpHeight * 0.8;
                var vpBoundaryTop = vpHeight * 0.3;

                var isVisible = rect.bottom > vpBoundaryTop && rect.top < vpBoundaryBottom;

                if (isVisible) {
                    animateScroll();
                }
            });

            itemNode.find(".swipeslider__item").each(function(){
                if($(this).hasClass("focusthis")){
                    itemNode.addClass("noanimate");
                    pos.snapCandidate = $(this)[0];
                    snapTo();
                }
            });
        };

        function initStatic(){
            swipeslider.find(".swipeslider__items").css("cursor","pointer");
            swipeslider.find(".swipeslider__left,.swipeslider__right").hide();
            swipeslider.find(".swipeslider__item").each(function(){
                if($(this).attr("data-href")){
                    $(this).on("click",function(){
                        if($(this)[0].fireET !== "undefined"){
                            try{
                                $(this)[0].fireET();
                            }
                            catch(e){
                                console.warn(e.message);
                            }
                        }
                        window.open($(this).attr("data-href"), '_blank').focus();
                    });
                }
            });
        }

        if(isStatic){
            initStatic();
        }
        else if(isEmpty){
            swipeslider.remove();
        }
        else{
            initSlider();
        }

    });
}

